enum UserAppellation {
  MR = 'Mister',
  MSS = 'Miss',
  DIVERSE = 'Diverse',
}

enum UserAppellationKey {
  MR = 'MR',
  MSS = 'MSS',
  DIVERSE = 'DIVERSE',
}

export { UserAppellation, UserAppellationKey };
